export interface ActionButton {
  action: string;
  link?: string;
  label: string;
}

export interface ErrorModalInfo {
  modalHeader: string;
  modalDetails: string;
  primaryAction: ActionButton;
  alternateAction?: ActionButton;
}
export interface ErrorModal {
  [key: string]: ErrorModalInfo;
}
